module.exports = __webpack_public_path__ + "static/media/lobby.5b8708b1.mp3";